import script from "./InvestFormTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestFormTotals.vue?vue&type=script&setup=true&lang=ts"

import "./InvestFormTotals.vue?vue&type=style&index=0&id=37c189f6&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c189f6"]])

export default __exports__